import type { ExtranetTripCancellationReason, ExtranetTripStatus } from '../../types/extranet-api.types';

const STATUS_LABELS: Record<ExtranetTripStatus, string> = {
  served: 'Servie',
  upcoming: 'À venir',
  cancelled: 'Annulée',
};

const STATUS_COLORS: Record<ExtranetTripStatus, { bg: string; text: string; dot: string }> = {
  served: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500' },
  upcoming: { bg: 'bg-blue-50', text: 'text-blue-700', dot: 'bg-blue-500' },
  cancelled: { bg: 'bg-zinc-100', text: 'text-zinc-600', dot: 'bg-zinc-400' },
};

const CANCELLATION_LABELS: Record<ExtranetTripCancellationReason, string> = {
  no_show_passenger: 'No-show passager',
  passenger_cancel: 'Annulation passager',
  allocab_cancel: 'Annulation Allocab',
};

interface RideStatusBadgeProps {
  status: ExtranetTripStatus;
  cancellationReason?: ExtranetTripCancellationReason | null;
}

export const RideStatusBadge = ({ status, cancellationReason }: RideStatusBadgeProps) => {
  const tokens = STATUS_COLORS[status];
  const label = STATUS_LABELS[status];
  return (
    <span className="inline-flex items-center gap-2">
      <span
        className={`inline-flex items-center gap-1.5 rounded-md text-xs font-medium px-2 py-0.5 ${tokens.bg} ${tokens.text}`}
      >
        <span className={`h-1.5 w-1.5 rounded-full ${tokens.dot}`} aria-hidden />
        {label}
      </span>
      {status === 'cancelled' && cancellationReason ? (
        <span className="text-xs text-zinc-500">{CANCELLATION_LABELS[cancellationReason]}</span>
      ) : null}
    </span>
  );
};
